import { EMPTY_LIST } from '../../../../constants/common'

export function getRequestsDataItems({ data }) {
  return data?.items || EMPTY_LIST
}

export function getTasksDataItems({ data }) {
  return data?.items || EMPTY_LIST
}

export function getEmailsItems({ data }) {
  return data?.items || EMPTY_LIST
}
